const VideoIcon = () => {
  return (
    <svg
      version="1.1"
      id="svg57"
      width="682.66669"
      height="682.66669"
      viewBox="0 0 682.66669 682.66669"
    >
      <defs id="defs61">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath71">
          <path d="M 0,512 H 512 V 0 H 0 Z" id="path69" />
        </clipPath>
      </defs>
      <g id="g63" transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
        <g id="g65">
          <g id="g67" clipPath="url(#clipPath71)">
            <g id="g73" transform="translate(498.8813,210.7212)">
              <path
                d="m 0,0 c -21.253,-114.234 -121.448,-200.721 -241.842,-200.721 -135.862,0 -246,110.138 -246,246 0,135.862 110.138,246 246,246 120.311,0 220.449,-86.367 241.798,-200.484"
                style={{
                  fill: "none",
                  stroke: "#000000",
                  strokeWidth: 20,
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeMiterlimit: 10,
                  strokeDasharray: "none",
                  strokeOpacity: 1,
                }}
                id="path75"
              />
            </g>
            <g id="g77" transform="translate(500.9604,256)">
              <path
                d="M 0,0 V 0"
                style={{
                  fill: "none",
                  stroke: "#000000",
                  strokeWidth: 20,
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeMiterlimit: 10,
                  strokeDasharray: "none",
                  strokeOpacity: 1,
                }}
                id="path79"
              />
            </g>
            <g id="g81" transform="translate(447.8511,256)">
              <path
                d="m 0,0 c 0,-105.957 -85.895,-191.851 -191.851,-191.851 -105.957,0 -191.851,85.894 -191.851,191.851 0,105.957 85.894,191.851 191.851,191.851 C -85.895,191.851 0,105.957 0,0 Z"
                style={{
                  fill: "none",
                  stroke: "#000000",
                  strokeWidth: 20,
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeMiterlimit: 10,
                  strokeDasharray: "none",
                  strokeOpacity: 1,
                }}
                id="path83"
              />
            </g>
            <g id="g85" transform="translate(322.2832,236.564)">
              <path
                d="m 0,0 -86.028,-58.733 c -15.62,-10.664 -36.803,0.522 -36.803,19.436 V 78.169 c 0,18.914 21.183,30.101 36.803,19.436 L 0,38.872 C 13.686,29.528 13.686,9.344 0,0 Z"
                style={{
                  fill: "none",
                  stroke: "#000000",
                  strokeWidth: 20,
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeMiterlimit: 10,
                  strokeDasharray: "none",
                  strokeOpacity: 1,
                }}
                id="path87"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default VideoIcon;